import { MyrAPIService } from '../../../../api/myr/myrAPI';
import { IRewardsTransactionsHistoryResponse } from '../../rewardsClub.interface';
import { MyrAPIEndpoints } from '../../../../api/myr/myrAPIEndpoints.constant';

export interface IHistoryEntry {
    transactionTime: string;
    type: string;
    action: string;
    historyUrl: string | null;
    historyText: string | null;
    orderNo: string;
    stdChange: number;
    termChange: number;
    expiryTime: string;
    transactionId: string;
    hiddenFlag: boolean;
    logo: string | null;
}

interface IData {
    year: string;
    month: string;
    currency: string;
}

export async function getRewardsTransactionsHistory(data: IData) {
    const year = data.year;
    const month = data.month;
    const response = await MyrAPIService.sendRequest<IRewardsTransactionsHistoryResponse>(
        `${MyrAPIEndpoints.POINTS}/transaction/${data.currency}`,
        'GET',
        {
            year,
            month,
        },
    );
    return {
        ...response,
        history: response.history.sort(dateSorter).map((entry) => ({
            ...entry,
            logo: setLogo(entry),
            transactionTime: formatDate(entry),
        })),
    };
}

const dateSorter = (a: IHistoryEntry, b: IHistoryEntry) =>
    new Date(a.transactionTime).getTime() - new Date(b.transactionTime).getTime();

export function setLogo(historyEntry: IHistoryEntry) {
    if (!historyEntry.historyUrl) {
        return 'rakuten';
    } else {
        const historyText = historyEntry.historyUrl.toLowerCase();
        if (historyText.includes('viber')) return 'viber';
        else if (historyText.includes('tv') || historyText.includes('wuaki')) {
            return 'tv';
        } else if (historyText.includes('kobo')) {
            return 'kobo';
        } else {
            return 'rakuten';
        }
    }
}

function formatDate(historyEntry: IHistoryEntry) {
    return new Date(historyEntry.transactionTime).toLocaleDateString();
}
